import store from '@/store';

export const getAuthHeader = () => ({
  Authorization: `Bearer ${store.state.token}`,
});
